import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCustomGradesFilters } from "../../services/JobPricingReportService";

export interface CustomGradesState {
  customGrades: any;
  isCustomGradesLoading: boolean;
  customGradesError: string | null;
}

const initialState: CustomGradesState = {
  customGrades: [],
  isCustomGradesLoading: false,
  customGradesError: null
};

export const getCustomGradesFiltersThunk = createAsyncThunk(
  "jobPricing/customGradesFilters",
  async (payload: any, thunkApi) => {
    try {
      const customgradesthunkdata = await getCustomGradesFilters(payload);
      return customgradesthunkdata;
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

const customGradesSlice = createSlice({
  name: "customGrades",
  initialState: initialState,
  reducers: {
    resetCustomGrades: (state) => {
      state.customGrades = [];
      state.isCustomGradesLoading = false;
      state.customGradesError = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomGradesFiltersThunk.pending, (state) => {
      state.isCustomGradesLoading = true;
      state.customGradesError = null;
    });
    builder.addCase(getCustomGradesFiltersThunk.fulfilled, (state, action) => {
      state.isCustomGradesLoading = false;
      state.customGrades = action.payload;
    });
    builder.addCase(getCustomGradesFiltersThunk.rejected, (state, action) => {
      state.isCustomGradesLoading = false;
    });
  }
});

export const { resetCustomGrades } = customGradesSlice.actions;

export default customGradesSlice.reducer;
